import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import GererateRequest from "./pages/GererateRequest";
import Request from "./pages/Request";
import NotFound from "./pages/NotFound";
import ThanksPage from "./pages/ThanksPage";
import ImageQR from "./pages/QRPayment";
import QRPage from "./pages/QRPage";
import ErrrorPago from "./pages/ErrrorPago";
import MpCheckout from "./pages/MpCheckout";
import MpResult from "./pages/MpResult";
import "./assets/css/all.min.css";
import "./assets/css/main.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
//import "@fortawesome/fontawesome-free/css/all.min.css";
function AppContainer() {
  return (
    <Router>
      <div>
        {/* Renderiza el header en todas las páginas */}

        <Routes>
          {/* Rutas para la página de inicio */}
          <Route
            exact
            path="/api/v1/generate-request/:company_code"
            element={<GererateRequest />} // Usa la clase Home como componente
          />
          <Route
            exact
            path="/api/v1/generate-request/:company_code/:order_id"
            element={<GererateRequest />} // Usa la clase Home como componente
          />

          <Route
            exact
            path="/api/v1/request/:company_code"
            element={<Request />} // Usa la clase Home como componente
          />
          <Route
            exact
            path="/api/v1/request/:company_code/:qr_id"
            element={<Request />} // Usa la clase Home como componente
          />
          <Route
            exact
            path="/api/v1/pago-satisfactorio/:qr_id"
            element={<ThanksPage />} // Usa la clase Home como componente
          />

          <Route
            exact
            path="/api/v1/error-pago/:qr_id"
            element={<ErrrorPago />} // Usa la clase Home como componente
          />
          <Route
            exact
            path="/api/v1/error-pago/:qr_id/:message"
            element={<ErrrorPago />} // Usa la clase Home como componente
          />

          <Route
            exact
            path="/api/v1/qr-image/:qr_id"
            element={<ImageQR />} // Usa la clase Home como componente
          />
          <Route
            exact
            path="/api/v1/generar-qr/:id_pedido/:email"
            element={<QRPage />} // Usa la clase Home como componente
          />

          {/* ── Mercado Pago (Checkout Pro) ── */}
          <Route path="/mp/pay/:org/:order_id" element={<MpCheckout />} />
          <Route path="/mp/success" element={<MpResult variant="success" />} />
          <Route path="/mp/failure" element={<MpResult variant="failure" />} />
          <Route path="/mp/pending" element={<MpResult variant="pending" />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default AppContainer;
